// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniCartLineStyles } from "@synd/App/Components/MiniCart/MiniCartLineCard";
import cartLineSharedStyles from "@synd/App/SharedStyles/CartLineSharedStyles";
import Close from "@synd/XDL/Icons/Close";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, mergeWithCss } from "@synd/XDL/Utilities";
import { css } from "styled-components";

miniCartLineStyles.cartLine = {
    css: css`
        display: grid;
        grid-template-columns: 80px 1fr 16px;
        position: relative;
        gap: 12px;
        margin-right: 16px;
    `,
};

miniCartLineStyles.cartLineImage = {
    img: {
        width: "80px",
        height: "80px",
    },
    linkWrappingImage: {
        css: css`
            width: 100%;
            grid-column: 1/2;
        `,
    },
};

miniCartLineStyles.lineDescriptionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 2px;
        grid-column: 2 / 3;
        overflow: hidden;
        width: 100%;
    `,
};

miniCartLineStyles.descriptionStyles = {
    productDetailSubDescription: {
        css: css`
            min-height: auto;
        `,
    },
};

miniCartLineStyles.qtyAndPriceWrapper = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin-top: 6px;
        gap: 54px;
    `,
};

miniCartLineStyles.extendedUnitNetPriceText = {
    css: css`
        display: flex;
        flex: 1;
        font-size: ${fontConfig.smallSingleLine.size}px;
        line-height: ${fontConfig.smallSingleLine.lineHeight};
        font-weight: ${fontConfig.weight.semiBold};

        ${({ isInvalidPrice }: any) =>
            isInvalidPrice &&
            css`
                color: ${color("danger")};
            `}
    `,
};

miniCartLineStyles.cartLineQuantityWrapper = {
    css: css`
        display: flex;
        flex: 1;
        align-items: center;
        min-width: 144px;
        ${({ showQtyTooltip }: any) => (showQtyTooltip ? `gap: 4px;` : `gap: 8px;`)};
    `,
};

miniCartLineStyles.errorMessagesWrapper = {
    css: css`
        display: flex;
        flex: 1;
        gap: 4px;
        align-items: center;
    `,
};

miniCartLineStyles.removeCartLineLink = {
    icon: {
        iconProps: {
            src: Close,
            size: 16,
            css: css`
                &,
                svg {
                    width: 12px;
                    :hover {
                        color: ${color("common.ui10")};
                    }
                }
            `,
        },
    },
    css: css`
        grid-column: 3 / 4;
        grid-row: 1;
        align-items: start;
        height: fit-content;
    `,
};

miniCartLineStyles.removeConfirmation = {
    css: css`
        grid-column: 1 / 4;
        display: flex;
        gap: 12px;
        align-items: center;
        padding: 8px;
        background-color: ${color("common.ui8")};
    `,
};

miniCartLineStyles.notifyStyles = {
    ...mergeWithCss(cartLineSharedStyles.notifyStyles, {
        css: css`
            grid-column: 1/3;
            margin: 0;
        `,
    }),
};

miniCartLineStyles.quoteMessageWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 4px;
    `,
};

miniCartLineStyles.quoteMessage = {
    color: "danger",
    ...fontConfig.xSmall,
    weight: fontConfig.weight.bold,
};

miniCartLineStyles.quoteTooltip = {
    mergeCss: true,
    iconProps: {
        size: 12,
    },
};

miniCartLineStyles.errorMsgTooltip = {
    mergeCss: true,
    extendedStyles: {
        triggerWrapper: {
            css: css`
                margin-left: 0;
            `,
        },
    },
};

miniCartLineStyles.cartLineQuantityStyles = {
    qtyLabelContainer: {
        css: css`
            gap: 8px;
        `,
    },
};
